import { useRef, useEffect } from "react";

const useSwipeGestures = (
  onSwipeLeft,
  onSwipeRight,
  minSwipeDistance = 100,
) => {
  const touchRef = useRef({
    startX: null,
    startY: null,
    endX: null,
    endY: null,
  });
  const callbackRef = useRef({ onSwipeLeft, onSwipeRight, minSwipeDistance });

  useEffect(() => {
    callbackRef.current = { onSwipeLeft, onSwipeRight, minSwipeDistance };
  }, [onSwipeLeft, onSwipeRight, minSwipeDistance]);

  useEffect(() => {
    // Check if touch started inside a horizontally scrollable container
    const isInsideScrollable = (el) => {
      while (el) {
        if (el.scrollWidth > el.clientWidth && getComputedStyle(el).overflowX === "auto") {
          return true;
        }
        el = el.parentElement;
      }
      return false;
    };

    const onTouchStart = (e) => {
      touchRef.current = {
        startX: e.targetTouches[0].clientX,
        startY: e.targetTouches[0].clientY,
        endX: null,
        endY: null,
        inScrollable: isInsideScrollable(e.target),
      };
    };

    const onTouchMove = (e) => {
      touchRef.current.endX = e.targetTouches[0].clientX;
      touchRef.current.endY = e.targetTouches[0].clientY;
    };

    const onTouchEnd = () => {
      const { startX, startY, endX, endY, inScrollable } = touchRef.current;
      if (startX === null || endX === null) return;

      // Don't fire swipe if touch started in a scrollable container
      if (inScrollable) return;

      const distX = startX - endX;
      const distY = Math.abs(startY - endY);

      // Ignore if vertical movement exceeds horizontal (scrolling, not swiping)
      if (distY > Math.abs(distX)) return;

      const {
        onSwipeLeft: left,
        onSwipeRight: right,
        minSwipeDistance: min,
      } = callbackRef.current;

      if (distX > min && left) {
        left();
      } else if (distX < -min && right) {
        right();
      }
    };

    document.addEventListener("touchstart", onTouchStart);
    document.addEventListener("touchmove", onTouchMove);
    document.addEventListener("touchend", onTouchEnd);

    return () => {
      document.removeEventListener("touchstart", onTouchStart);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", onTouchEnd);
    };
  }, []);

  return null;
};

export default useSwipeGestures;
